<div class="bgcd-wrapper">

  <!-- Branch GST Details-->
  <div class="bgcd-section-inner">
    <div class="bgcd-subsection-header">
      <span class="bgcd-subsection-title">Branch GST Details</span>
      <div class="bgcd-header-actions">
        <button mat-icon-button type="button" (click)="addGSTRow()"
                *ngIf="!disableTable" matTooltip="Add Row" class="bgcd-add-btn">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>

    <form [formGroup]="branchTaxDetailForm">
      <div class="bgcd-table-wrapper">
      <table mat-table [dataSource]="branchGSTDataSource" formArrayName="taxDetialsDto"
             class="bgcd-table" [ngClass]="{'row-disabled': disableTable}">

        <!-- Branch GST No -->
        <ng-container matColumnDef="gstNo">
          <th mat-header-cell *matHeaderCellDef>Branch GST No</th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
            <mat-form-field appearance="fill" class="bgcd-field">
              <input matInput formControlName="gstNo" placeholder="GST No" autocomplete="off"
                     maxlength="15" (input)="onGSTNoChange(i)" (blur)="onGSTNoBlur(i)">
              <mat-error *ngIf="taxDetialsDto.at(i).get('gstNo')?.touched && taxDetialsDto.at(i).get('gstNo')?.hasError('required')">
                Branch GST No is required
              </mat-error>
              <mat-error *ngIf="taxDetialsDto.at(i).get('gstNo')?.touched && taxDetialsDto.at(i).get('gstNo')?.hasError('maxlength')">
                Max 15 characters allowed
              </mat-error>
              <mat-error *ngIf="taxDetialsDto.at(i).get('gstNo')?.touched && taxDetialsDto.at(i).get('gstNo')?.hasError('pattern')
                                && !taxDetialsDto.at(i).get('gstNo')?.hasError('maxlength')">
                Invalid GST format (e.g. 29ABCDE1234F1Z5)
              </mat-error>
              <mat-error *ngIf="taxDetialsDto.at(i).get('gstNo')?.hasError('duplicate')">
                GST No already used in another row
              </mat-error>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Description / Business Vertical -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Description / Business Vertical</th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
            <mat-form-field appearance="fill" class="bgcd-field">
              <input matInput formControlName="description" placeholder="Description" autocomplete="off" maxlength="200"
                     (blur)="trimFieldValue(i, 'description')">
              <mat-error *ngIf="taxDetialsDto.at(i).get('description')?.touched && taxDetialsDto.at(i).get('description')?.hasError('maxlength')">
                Max 200 characters allowed
              </mat-error>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Action -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
            <span class="__action_delete_icon"
                  (click)="deleteGSTRow(i)"
                  *ngIf="!disableTable && taxDetialsDto.length > 1"
                  matTooltip="Delete">
              <mat-icon>delete</mat-icon>
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedGstColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedGstColumns;"></tr>
      </table>
      </div>
    </form>
  </div>

  <!-- Branch Customer Credit Details -->
  <div class="bgcd-section-inner bgcd-section-inner--mt" *ngIf="customerFlag">
    <div class="bgcd-subsection-header">
      <span class="bgcd-subsection-title">Branch Customer Credit Details</span>
      <div class="bgcd-header-actions">
        <button mat-icon-button type="button" (click)="addCustomerCreditRow()"
                *ngIf="!disableTable" matTooltip="Add Row" class="bgcd-add-btn">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>

    <form [formGroup]="branchCreditDetailsForm">
      <div class="bgcd-table-wrapper">
        <table mat-table [dataSource]="branchCustomerCreditDataSource" formArrayName="branchCustomerCreditDetails"
               class="bgcd-table" [ngClass]="{'row-disabled': disableTable}">

          <!-- Business Segment -->
          <ng-container matColumnDef="businessSegment">
            <th mat-header-cell *matHeaderCellDef>Business Segment</th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
              <mat-form-field appearance="fill" class="bgcd-field">
                <mat-select formControlName="businessSegmentId" placeholder="Select"
                            (selectionChange)="onCustomerCreditSegmentSelect(i, $event.value)">
                  <mat-option *ngFor="let seg of businessSegments" [value]="seg.businessSegmentId">
                    {{seg.businessSegmentName}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="branchCustomerCreditDetails.at(i).get('businessSegmentId')?.touched && branchCustomerCreditDetails.at(i).get('businessSegmentId')?.hasError('required')">
                  Business Segment is required
                </mat-error>
                <mat-error *ngIf="branchCustomerCreditDetails.at(i).get('businessSegmentId')?.hasError('duplicate')">
                  Business Segment already used in another row
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Credit Days -->
          <ng-container matColumnDef="creditDays">
            <th mat-header-cell *matHeaderCellDef>Credit Days</th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
              <mat-form-field appearance="fill" class="bgcd-field">
                <input matInput formControlName="creditDays" placeholder="Days" autocomplete="off"
                       inputmode="numeric"
                       (input)="sanitizeInteger($event, branchCustomerCreditDetails.at(i).get('creditDays'))">
                <mat-error *ngIf="branchCustomerCreditDetails.at(i).get('creditDays')?.touched && branchCustomerCreditDetails.at(i).get('creditDays')?.hasError('pattern')">
                  Must be a whole number greater than 0
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Credit Amount -->
          <ng-container matColumnDef="creditAmount">
            <th mat-header-cell *matHeaderCellDef>Credit Amount</th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
              <mat-form-field appearance="fill" class="bgcd-field">
                <input matInput formControlName="creditAmount" placeholder="Amount" autocomplete="off"
                       inputmode="decimal"
                       (input)="sanitizeDecimal($event, branchCustomerCreditDetails.at(i).get('creditAmount'))">
                <mat-error *ngIf="branchCustomerCreditDetails.at(i).get('creditAmount')?.touched && branchCustomerCreditDetails.at(i).get('creditAmount')?.hasError('pattern')">
                  Must be a number greater than 0
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Currency -->
          <ng-container matColumnDef="currency">
            <th mat-header-cell *matHeaderCellDef>Currency</th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
              <mat-form-field appearance="fill" class="bgcd-field">
                <mat-select formControlName="currencyId" placeholder="Select"
                            (selectionChange)="onCustomerCurrencySelect(i, $event.value)">
                  <mat-option>
                    <ngx-mat-select-search [searching]="searching" [formControl]="currencySearchCtrl"
                        noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Currency">
                      <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="null">None</mat-option>
                  <mat-option *ngFor="let curr of filteredCurrency | async" [value]="curr.id">
                    {{curr.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Action -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
              <span class="__action_delete_icon"
                    (click)="deleteCustomerCreditRow(i)"
                    *ngIf="!disableTable"
                    matTooltip="Delete">
                <mat-icon>delete</mat-icon>
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedCreditColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedCreditColumns;"></tr>
        </table>
      </div>
      <mat-error *ngIf="customerCreditSumError" class="bgcd-credit-sum-error">{{ customerCreditSumError }}</mat-error>
    </form>
  </div>

  <!-- Branch Vendor Credit Details -->
  <div class="bgcd-section-inner bgcd-section-inner--mt" *ngIf="vendorFlag">
    <div class="bgcd-subsection-header">
      <span class="bgcd-subsection-title">Branch Vendor Credit Details</span>
      <div class="bgcd-header-actions">
        <button mat-icon-button type="button" (click)="addVendorCreditRow()"
                *ngIf="!disableTable" matTooltip="Add Row" class="bgcd-add-btn">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>

    <form [formGroup]="branchCreditDetailsForm">
      <div class="bgcd-table-wrapper">
        <table mat-table [dataSource]="branchVendorCreditDataSource" formArrayName="branchVendorCreditDetails"
               class="bgcd-table" [ngClass]="{'row-disabled': disableTable}">

          <!-- Business Segment -->
          <ng-container matColumnDef="businessSegment">
            <th mat-header-cell *matHeaderCellDef>Business Segment</th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
              <mat-form-field appearance="fill" class="bgcd-field">
                <mat-select formControlName="businessSegmentId" placeholder="Select"
                            (selectionChange)="onVendorCreditSegmentSelect(i, $event.value)">
                  <mat-option *ngFor="let seg of businessSegments" [value]="seg.businessSegmentId">
                    {{seg.businessSegmentName}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="branchVendorCreditDetails.at(i).get('businessSegmentId')?.touched && branchVendorCreditDetails.at(i).get('businessSegmentId')?.hasError('required')">
                  Business Segment is required
                </mat-error>
                <mat-error *ngIf="branchVendorCreditDetails.at(i).get('businessSegmentId')?.hasError('duplicate')">
                  Business Segment already used in another row
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Credit Days -->
          <ng-container matColumnDef="creditDays">
            <th mat-header-cell *matHeaderCellDef>Credit Days</th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
              <mat-form-field appearance="fill" class="bgcd-field">
                <input matInput formControlName="creditDays" placeholder="Days" autocomplete="off"
                       inputmode="numeric"
                       (input)="sanitizeInteger($event, branchVendorCreditDetails.at(i).get('creditDays'))">
                <mat-error *ngIf="branchVendorCreditDetails.at(i).get('creditDays')?.touched && branchVendorCreditDetails.at(i).get('creditDays')?.hasError('pattern')">
                  Must be a whole number greater than 0
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Credit Amount -->
          <ng-container matColumnDef="creditAmount">
            <th mat-header-cell *matHeaderCellDef>Credit Amount</th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
              <mat-form-field appearance="fill" class="bgcd-field">
                <input matInput formControlName="creditAmount" placeholder="Amount" autocomplete="off"
                       inputmode="decimal"
                       (input)="sanitizeDecimal($event, branchVendorCreditDetails.at(i).get('creditAmount'))">
                <mat-error *ngIf="branchVendorCreditDetails.at(i).get('creditAmount')?.touched && branchVendorCreditDetails.at(i).get('creditAmount')?.hasError('pattern')">
                  Must be a number greater than 0
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Currency -->
          <ng-container matColumnDef="currency">
            <th mat-header-cell *matHeaderCellDef>Currency</th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
              <mat-form-field appearance="fill" class="bgcd-field">
                <mat-select formControlName="currencyId" placeholder="Select"
                            (selectionChange)="onVendorCurrencySelect(i, $event.value)">
                  <mat-option>
                    <ngx-mat-select-search [searching]="searching" [formControl]="currencySearchCtrl"
                        noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Currency">
                      <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="null">None</mat-option>
                  <mat-option *ngFor="let curr of filteredCurrency | async" [value]="curr.id">
                    {{curr.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Action -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
              <span class="__action_delete_icon"
                    (click)="deleteVendorCreditRow(i)"
                    *ngIf="!disableTable"
                    matTooltip="Delete">
                <mat-icon>delete</mat-icon>
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedCreditColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedCreditColumns;"></tr>
        </table>
      </div>
      <mat-error *ngIf="vendorCreditSumError" class="bgcd-credit-sum-error">{{ vendorCreditSumError }}</mat-error>
    </form>
  </div>

  <div class="bgcd-actions" *ngIf="!buttonHidden">
    <button mat-button color="primary" (click)="onSave()">Save</button>
    <button mat-button color="cancel" (click)="onCancel()">Cancel</button>
  </div>

</div>
